// @noflow
const planTypes = ['all', 'most', 'half', 'some'] as const

type PlanType = (typeof planTypes)[number]

export { PlanType, planTypes }
